import React from 'react'
import { Outlet } from 'react-router-dom'

const Transport = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default Transport;